import React from 'react';
import './Home.css';
import HeroSection from '../components/sections/HeroSection';
import TargetsSection from '../components/sections/TargetsSection';
import ShareSection from '../components/sections/ShareSection';
// import StatsSection from '../components/sections/StatsSection';
import VideoSection from '../components/sections/VideoSection';
// import MediaSection from '../components/sections/MediaSection';
import FormSection from '../components/sections/FormSection';

const Home = () => {
  return (
    <div className="flex flex-col lg:w-3/4 max-w-[1200px] mx-auto items-center gap-2 px-2 lg:px-0">
      <HeroSection />
      <TargetsSection />
      <ShareSection />
      <FormSection />
      {/* <StatsSection /> */}
      <VideoSection />
      {/* <MediaSection /> */}
    </div>
  );
};

export default Home;
